import React from "react";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";

import Header from "./Header";
import Footer from "./Footer";

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    backgroundColor: theme.palette.background.default,
    color: theme.palette.text.primary,
  },
  contentContainer: {
    flexGrow: 1,
    padding: theme.spacing(3),
    marginTop: theme.spacing(4),
  },
  footerContainer: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  }
}));

const Main = ({ children }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Header />

      <Grid container className={classes.contentContainer} justify="center">
        <Grid item xs={12} sm={12}>
          {children}
        </Grid>
      </Grid>

      <div className={classes.footerContainer}>
        <Footer />
      </div>
    </div>
  );
};

export default Main;
